import { PropertyType } from '../../../common';

export const mapToFormData = (data: PropertyType): PropertyType => {
	const formData = new FormData();
	const keys = Object.keys(data);

	keys.forEach((key) => {
		if (key !== 'filters') {
			formData.append(key, data[key]);
		} else {
			formData.append(key, JSON.stringify(data[key]));
		}
	});
	return formData;
};

export const mapEntityToApi = (data: PropertyType): PropertyType => {
	const { gameCategoryForm, token } = data;
	const apiData: PropertyType = {
		sid: token,
	};

	if (gameCategoryForm.game_name) apiData.name = gameCategoryForm.game_name;

	return apiData;
};
